import Link from "next/link";
import { FC } from "react";
import { useTranslation } from "next-i18next";
import {
  CheckBoxPrivacyType,
  i18translateType,
} from "../../../../@types/types-body";

export const CheckBoxPrivacy: FC<CheckBoxPrivacyType> = ({
  id,
  model,
  onChange,
}) => {
  const { t }: i18translateType = useTranslation("common");
  return (
    <div
      className="flex w-full items-center mb-4 text-center mx-auto"
      id={`accept-privacy-${id}`}
    >
      <input
        id="link-checkbox"
        type="checkbox"
        value={JSON.stringify(model)}
        className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500
                           dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-800 dark:border-gray-600"
        checked={model}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label
        htmlFor="link-checkbox"
        className="ml-2 text-base font-medium text-gray-900 dark:text-gray-300"
      >
        {t("accept_privacy")}
        <Link
          href={t("menu.path.data-protection")}
          className="ml-1 text-crowlyn-light hover:underline"
        >
          {t("accept_privacy_link")}
        </Link>
        .
      </label>
    </div>
  );
};
